/* tslint:disable */
/* eslint-disable */
/**
 * Eatgrim Shipping API
 * Eatgrim Shipping API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tech@soundsgood.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CountryFromJSON, CountryToJSON, } from './';
export function DoorstepPayloadFromJSON(json) {
    return DoorstepPayloadFromJSONTyped(json, false);
}
export function DoorstepPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'country': CountryFromJSON(json['country']),
        'shopifyProductId': json['shopifyProductId'],
        'timeEntryId': !exists(json, 'timeEntryId') ? undefined : json['timeEntryId'],
        'zipCode': !exists(json, 'zipCode') ? undefined : json['zipCode'],
    };
}
export function DoorstepPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'country': CountryToJSON(value.country),
        'shopifyProductId': value.shopifyProductId,
        'timeEntryId': value.timeEntryId,
        'zipCode': value.zipCode,
    };
}
